module.exports = __webpack_public_path__ + "assets/img/icon3.caf584f9.png";